function Session(user, authType, customer, pension, showLoginDisclaimer) {
  this.user = user
  this.customer = customer
  this.authType = authType
  this.showLoginDisclaimer = showLoginDisclaimer

  this.setPension = function (pension) {
    this.pension = pension
  }

  this.setCustomer = function (customer) {
    this.customer = customer
  }

  this.setQuestionnaireStatus = function (questionnaireStatus) {
    this.questionnaireStatus = questionnaireStatus
  }

  if (pension) this.setPension(pension)

  this.hasContactData = function () { //TODO refactor
    return !!(this.user.phone && this.user.email)
  }
}